
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
export default function Leaderboard({ candidates }) {
  return (
    <section className='pb-4 mb-4'>


      <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">Candidate Leaderboard</h2>
      <DataTable className='table-shadow' value={candidates} tableStyle={{ minWidth: '50rem' }}>
        <Column field="rank" header="Rank"></Column>
        <Column field="candidateName" header="Candidate"></Column>
        <Column field="politicalParty" header="Party"></Column>
        <Column field="totalVotes" header="Votes"></Column>
        <Column field="percentage" header="Percentage" body={c => <>{c.percentage}%</>}></Column>
      </DataTable>
    </section>
  );
}
